import { Spline } from "react-spline";
import SCENE_OBJECT from "../scene1";

function Spline3d() {
  return <Spline scene={SCENE_OBJECT} className="spline-3d" />;
}

export default Spline3d;
